import { render, staticRenderFns } from "./project-tracker.vue?vue&type=template&id=fd5274fa&scoped=true&"
import script from "./project-tracker.vue?vue&type=script&lang=js&"
export * from "./project-tracker.vue?vue&type=script&lang=js&"
import style0 from "./project-tracker.vue?vue&type=style&index=0&id=fd5274fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5274fa",
  null
  
)

export default component.exports